import PageTemplate from "./PageTemplate";
import Experience from "../../../Experience";
import Home from "./Home";

export default class Projects {
    constructor() {

        this.experience = new Experience()
        this.home = new Home()
        this.interaction = this.home.interaction
        this.resources = this.experience.resources



        if (this.resources.loaded === this.resources.toLoad) {
            this.setup()
        }
        else {
            this.resources.on("ready", () => {
                this.setup()
            })
        }
    }

    setup() {

        this.project1Image = this.resources.items.stickingTogether
        this.project2Image = this.resources.items.gloppyTheSlime
        this.project3Image = this.resources.items.lorenzAttractor
        this.project4Image = this.resources.items.rayMarching2D
        this.project5Image = this.resources.items.sierpinskiTriangle
        this.project6Image = this.resources.items.cibo
        this.project2 = {
            name: "Sticking Together",
            image: this.project1Image,
            listDescription: "2D platformer game where you control 2 robots",
            link: "https://abhishekgusain.itch.io/stickingtogether",
            detailedDescription: "This game was my first project that I ever made with Unity on my own. The game follows a 2 robots and the player needs to use them both in border to complete levels. I made almost everything on my own except the music. This was a fun project and I learned a lot about Post Processing, Lighting, Scripting and overall how Unity works.\n\nTechnologies:\nUnity, C#"
        }
        this.project3 = {
            name: "Gloppy the Slime",
            image: this.project2Image,
            listDescription: "Submission for the Newbies GameJam",
            link: "https://abhishekgusain.itch.io/gloppy-the-slime",
            detailedDescription: "This was a submission for Newbies GameJam where we were given 2 weeks to make a game based on the theme 'Death = Progress'. \nI got 13th place overall in the whole Jam.\nThe game is a puzzle platformer and you make dead slimes to complete the levels\n\nTechnologies:\nUnity, C#"
        }
        this.project1 = {
            name: "CIBO",
            image: this.project6Image,
            listDescription: "ML app that recommends recipes based on the ingredients",
            link: "https://github.com/AbhishekGusain1289/CIBOserver",
            detailedDescription: "This was a college project, the user selects ingredients and then the app suggests dishes that the user can make based on the ingredients. We used TF-IDF for our recommendations which was designed by me in python. I was responsible for the ML model and designing the UI for the app along with all the testing. \n\nTechnologies:\nPython"
        }
        this.projectsList = [this.project1, this.project2, this.project3]


        this.template = new PageTemplate(
            "Projects",
            "#FEFA2E",
            "#EA2A78",
            this.projectsList
        )
    }

    destroy() {
        this.template.destroy()
    }
}